const messagingTemplatesRoute = {
	name: 'messaging-templates',
	path: 'messaging-templates',
	meta: {
		title: 'Plantillas de Mensajería',
	},
	redirect: 'messaging-templates/list',
	component: () => import('@/pages/configuration/page-messaging-templates'),
	children: [
		{
			name: 'list',
			path: 'list',
			component: () => import('@/components/configuration/messaging-templates/list-messaging-templates'),
		},
		{
			name: 'new',
			path: 'new',
			component: () => import('@/components/configuration/messaging-templates/new-messaging-templates'),
		},
	],
};

export default messagingTemplatesRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/messaging-templates/index.js